import { Grid } from "@mui/material";

export const BEEForum = () => {

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    BEE Forum
                </Grid>
            </Grid>
        </>);
}